import QuillLocalStorage from '../localStorageClient';

/**
 * Step 1: Hydrate the userid token of the clien
 * Step 2: Check if the servers are in maintainace mode
 *
 * Will be resolved if the request was let through
 */
export default (requestInstance: (token?: string) => void) =>
  new Promise<void>((resolve) => {
    const user =
      typeof window !== 'undefined' && window.firebase?.apps.length
        ? window.firebase.auth().currentUser
        : null;
    if (user) {
      user.getIdToken().then((token: string | undefined) => {
        requestInstance(token);
        QuillLocalStorage.getInstance().set('useridtoken', token || '', {
          expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
        });
        resolve();
      });
    } else {
      requestInstance();
      resolve();
    }
  });
